// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Slider__Wrapper_1FmsW","Title":"Slider__Title_22Ol4","Navigation":"Slider__Navigation_1pln8"};